export const TITLE = 'Honorários Judiciais';
export const ADD_TITLE = 'Adicionar Faixa de Honorários Judiciais';
export const ADD_TITLE_QUERY = 'Faixa de Honorários Judiciais';
export const ADD_HINT = 'Adicionar Faixa';
export const INITIAL = 'De';
export const FINAL = 'Até';
export const HONORARIOS_CONTRATUAIS_INICIAL = 'Percentual Inicial';
export const HONORARIOS_CONTRATUAIS_FINAL = 'Percentual Final';
export const COMBO_BOX_TYPE = 'Tipo';
